import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Account } from 'app/shared/models/account';
import { map, Observable, of } from 'rxjs';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class InActiveGuard implements CanActivate {
  accountInfo: Account;

  constructor(private commonService: CommonService, private router: Router) { }

  canActivate(): Observable<boolean> {
    const accountString = localStorage.getItem('account');

    if (!accountString) {
      this.router.navigate(['/login']);
      return of(false);
    }

    const accountInfo: Account = JSON.parse(accountString);

    if (!accountInfo?.id) {
      this.router.navigate(['/login']);
      return of(false);
    }

    return this.commonService.getInActiveStatus(accountInfo.id).pipe(
      map((inActive: boolean) => {
        if (inActive) {
          this.router.navigate(['/in-active']);
          return false;
        }
        return true;
      })
    );
  }
}
